<template>
  <Bar
    v-bind:chart-data="chartData"
    v-bind:chart-options="chartOptions"
    class="bar-dashboard"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';

/**
 * @description Генератор цветов
 * @return {Generator<string, void, *>}
 */
function* colorGenerator() {
  const colors = [
    '#0489E0',
    '#ff0000',
    '#D9E1EC',
    '#7371FF',
    '#EC782A',
    '#28b600',
    '#7f00af',
  ];
  let i = 0;
  while (i < colors.length) {
    const color = colors[i];
    yield color;
    i += 1;
    if (i === colors.length) {
      i = 0;
    }
  }
}

/**
 * @description Диаграмма "бар-чарт"
 */
export default {
  name: 'BarDashboard',
  components: {
    Bar,
  },
  computed: {
    chartData() {
      return {
        labels: this.items.map((item) => item[this.itemLabelKey]),
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            data: this.items.map((item) => item[this.itemValueKey]),
            barPercentage: 0.4,
          },
        ],
      };
    },
    backgroundColors() {
      let i = 0;
      const colors = [];
      const colorVendor = colorGenerator();
      while (i < this.items.length) {
        colors.push(colorVendor.next().value);
        i += 1;
      }
      return colors;
    },
  },
  data() {
    return {
      chartOptions: {
        ...this.options,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          ...this.plugins,
        },
      },
    };
  },
  props: {
    /**
     * @description Элементы диаграммы
     * @type {Array}
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * @description Ключ метки элемента
     * @type {string}
     */
    itemLabelKey: {
      type: String,
      default: () => 'label',
    },
    /**
     * @description Ключ значения элемента
     * @type {string}
     */
    itemValueKey: {
      type: String,
      default: () => 'value',
    },
    /**
     * @description Плагины
     * @type {Object}
     */
    plugins: {
      type: Object,
      default: () => {},
    },
    /**
     * @description Опции
     * @type {Object}
     */
    options: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.bar-dashboard {
  width: 100%;
  height: 400px;
}
@media screen and (max-width: 480px) {
  .bar-dashboard {
    width: 200px;
    height: 200px;
  }
}
</style>
